module.exports = __webpack_public_path__ + "img/scan.7ee7803d.svg";